import { $authHost } from ".."

export const getExpenseTypesAllAPI = async () => {
    const {data} = await $authHost.get(`api/expense_types/all`)
    return data
}